/**
 * /financeiro/* — router-shell do modulo Financeiro (Fase 13.1).
 *
 * Sub-rotas:
 *   /financeiro/dashboard (default)
 *   /financeiro/lancamentos
 *   /financeiro/lancamentos/criar
 *   /financeiro/lancamentos/importar-ofx
 *   /financeiro/cadastros (tabs Contas/Categorias/Centros)
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Dashboard from "./Dashboard";
import LancamentosLista from "./Lancamentos/Lista";
import LancamentoCriar from "./Lancamentos/Criar";
import LancamentoImportarOfx from "./Lancamentos/ImportarOfx";
import Cadastros from "./Cadastros";
import Comissoes from "./Comissoes";
import ConciliacaoBancaria from "./ConciliacaoBancaria";
import ContasAPagar from "./ContasPagarReceber/Pagar";
import ContasAReceber from "./ContasPagarReceber/Receber";
import DRE from "./DRE";
import FluxoCaixa from "./FluxoCaixa";
import RentabilidadePedidos from "./Rentabilidade";
import CustosIndiretos from "./CustosIndiretos";
import IntegracoesBancarias from "./IntegracoesBancarias";
import Cheques from "./Cheques";

export default function FinanceiroShell() {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="contas-pagar" element={<ContasAPagar />} />
      <Route path="contas-receber" element={<ContasAReceber />} />
      <Route path="lancamentos" element={<LancamentosLista />} />
      <Route path="lancamentos/criar" element={<LancamentoCriar />} />
      <Route path="lancamentos/importar-ofx" element={<LancamentoImportarOfx />} />
      <Route path="cadastros/*" element={<Cadastros />} />
      <Route path="dre" element={<DRE />} />
      <Route path="fluxo-caixa" element={<FluxoCaixa />} />
      <Route path="rentabilidade" element={<RentabilidadePedidos />} />
      <Route path="custos-indiretos" element={<CustosIndiretos />} />
      <Route path="comissoes" element={<Comissoes />} />
      <Route path="conciliacao-bancaria" element={<ConciliacaoBancaria />} />
      <Route path="integracoes-bancarias" element={<IntegracoesBancarias />} />
      <Route path="cheques" element={<Cheques />} />
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  );
}
